import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { redirectToPageNotFound, hideHelpAboutThisPage } from '../actions/shared';
import { queueESEvents, ESEventTypes } from 'businessLogic/logEventToElasticSearch';
import { useDispatch } from 'react-redux';
import { isAnyInputFormVisible, isAnyOverlayFormVisible } from '../businessLogic/form';

function NotFoundPage(props) {
  const dispatch = useDispatch();
  useEffect(() => {
    if (dispatch && props.routeName === 'NotFound') {
      //The Props.RouteName  is only found if the page access is not found in the react router
      //At this point the redirectToPageNotFound is false, (as it only get set at fetchinterceptor)
      dispatch(redirectToPageNotFound(true));
      if (props.preAction) {
        if (isAnyOverlayFormVisible() || isAnyInputFormVisible()) {
          dispatch(props.preAction());
        }
      }
    }
    dispatch(hideHelpAboutThisPage(true));
    queueESEvents(ESEventTypes.NotFoundPageShown, window.location.href, 'eventName');
    return () => {
      if (dispatch) dispatch(redirectToPageNotFound(false));
      dispatch(hideHelpAboutThisPage(false));
    };
  }, []);

  return (
    <div className="main-ui-container not-found-page" data-rendered-as-container="true">
      <div className="not-found-img">
        <img className="ui image mrbxl mrtl logo-image" src={APP.IMAGES.UmbrellaLogo} style={{ margin: 'auto' }} />
      </div>
      <h1>{APP.LANGUAGE.PageNotAvailable.MainHeading}</h1>
      <p>
        <b>{APP.LANGUAGE.PageNotAvailable.SubHeading}</b>
      </p>
      <p>{APP.LANGUAGE.PageNotAvailable.ReasonOne}</p>
      <p>{APP.LANGUAGE.PageNotAvailable.ReasonTwo}</p>
      <p>{APP.LANGUAGE.PageNotAvailable.ReasonThree}</p>
    </div>
  );
}

export default NotFoundPage;
